
    const changeToRgba =(arr) => {
      return `rgba(${arr[0]},${arr[1]},${arr[2]},1)`
    }


export default changeToRgba